var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { FooterWrapper } from "../footer/footer.component";
import { HeaderWrapper } from "../header/header.component";
import { ExternalSourcesInter } from "../../../../../shared/src/boot";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display        : flex;\n  flex-direction : column;\n  align-items    : center;\n  padding        : 32px;\n  height         : calc(100% - 64px);\n"], ["\n  display        : flex;\n  flex-direction : column;\n  align-items    : center;\n  padding        : 32px;\n  height         : calc(100% - 64px);\n"])));
export var BodyWrapper = function (_a) {
    var children = _a.children;
    return _jsxs(Wrapper, { children: [_jsx(HeaderWrapper, {}), children, _jsx(FooterWrapper, {}), _jsx(ExternalSourcesInter, {})] });
};
var templateObject_1;
//# sourceMappingURL=body.component.js.map